import { LessGlobals, parseLessString } from '../constants/lessGlobals.cjs';

function isDesktop() {
	return (
		typeof matchMedia === 'function' &&
		matchMedia(parseLessString(LessGlobals.media.desktop)).matches
	);
}

function isMobile() {
	return !isDesktop();
}

export { isDesktop, isMobile };
